export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordPattern = /^.{8,}$/;
export const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const requiredFieldMessage = 'Required';
export const requiredSubmitMessage = 'Fill in the required fields.';

export const emailValidationMessage = 'Enter a valid email';
export const passwordValidationMessage = 'Password must be at least 8 characters';
export const slugValidationMessage =
  'Use lowercase letters, numbers, and dashes (no leading/trailing dash)';

export const optionalLabel = (label: string): string => `${label} (Optional)`;

export type FieldErrorPayload = Record<string, string>;

export type FieldErrorDetails = {
  fieldErrors?: FieldErrorPayload;
  errors?: Array<{ field?: string; message?: string }>;
};

const isFieldErrorDetails = (value: unknown): value is FieldErrorDetails => {
  if (!value || typeof value !== 'object') return false;
  const record = value as { fieldErrors?: unknown; errors?: unknown };
  if (record.fieldErrors && typeof record.fieldErrors !== 'object') return false;
  if (record.errors && !Array.isArray(record.errors)) return false;
  return true;
};

export const getErrorDetails = (err: unknown): FieldErrorDetails | null => {
  if (!err || typeof err !== 'object') return null;
  const details = (err as { details?: unknown }).details;
  if (!details) return null;
  return isFieldErrorDetails(details) ? details : null;
};

export const extractFieldErrors = (details: FieldErrorDetails | null): FieldErrorPayload | null => {
  if (!details) return null;
  const fieldErrors = details.fieldErrors ?? null;
  if (fieldErrors && Object.keys(fieldErrors).length > 0) {
    return fieldErrors;
  }
  const errors = details.errors ?? null;
  if (!errors || errors.length === 0) return null;
  const mapped: FieldErrorPayload = {};
  errors.forEach((item) => {
    if (typeof item.field === 'string' && typeof item.message === 'string') {
      mapped[item.field] = item.message;
    }
  });
  return Object.keys(mapped).length > 0 ? mapped : null;
};

export const validateEmailValue = (value: string): string | null => {
  const trimmed = value.trim();
  if (!emailPattern.test(trimmed)) {
    return emailValidationMessage;
  }
  return null;
};

export const validatePasswordValue = (value: string): string | null => {
  if (!passwordPattern.test(value)) {
    return passwordValidationMessage;
  }
  return null;
};

export const validateSlugValue = (value: string): string | null => {
  const trimmed = value.trim();
  if (!slugPattern.test(trimmed)) {
    return slugValidationMessage;
  }
  return null;
};
